import {StoreIconType, StoreItemCategory} from '../../entity_datas/StoreEnums.ts'
import {BaseStoreItem} from '../BaseStoreItem.ts'
import {LobbyImage} from '@colonist/types'
import {type TranslationObject} from '@colonist/i18n'

// Image/item icons

export class SIIconRobberCupid extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.RobberCupid
    name: TranslationObject = {key: 'strings:storePage.icons.cupidRobber'}
    price = 250
    image = LobbyImage.IconRobberCupid
    activeInStore = true
}
export class SIIconRobberLunar extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.RobberLunar
    name: TranslationObject = {key: 'strings:storePage.icons.lunarRobber'}
    price = 250
    image = LobbyImage.IconRobberLunar
    activeInStore = true
}
export class SIIconRobberSanta extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.RobberSanta
    name: TranslationObject = {key: 'strings:storePage.icons.santaRobber'}
    price = 250
    image = LobbyImage.IconRobberSanta
    activeInStore = false
}

export class SIIconPirateShip extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.PirateShip
    name: TranslationObject = {key: 'strings:storePage.icons.pirateShip'}
    price = 250
    image = LobbyImage.IconPirateShip
    activeInStore = true
}

export class SIIconChristmasHat extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.ChristmasHat
    name: TranslationObject = {key: 'strings:storePage.icons.christmasHat'}
    price = 250
    image = LobbyImage.IconChristmasHat
    activeInStore = true
}

export class SIIconElephant extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Elephant
    name: TranslationObject = {key: 'strings:storePage.icons.elephant'}
    price = 250
    image = LobbyImage.IconElephant
    activeInStore = false
}

export class SIIconAvocado extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Avocado
    name: TranslationObject = {key: 'strings:storePage.icons.avocado'}
    price = 250
    image = LobbyImage.IconAvocado
    activeInStore = true
}

export class SIIconCactus extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Cactus
    name: TranslationObject = {key: 'strings:storePage.icons.cactus'}
    price = 250
    image = LobbyImage.IconCactus
    activeInStore = true
}

export class SIIconGifter extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Gifter
    name: TranslationObject = {key: 'strings:storePage.icons.gifter'}
    text: TranslationObject = {key: 'strings:storePage.sections.avatar.unlockByGifting'}
    image = LobbyImage.IconGifter
    activeInStore = true
    bannerText: TranslationObject = {key: 'strings:storePage.newItem'}
    hideOnDiscordMobile = true
}

export class SIIconCrown extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Crown
    name: TranslationObject = {key: 'strings:storePage.icons.crown'}
    price = 250
    image = LobbyImage.IconCrown
    activeInStore = true
}

export class SIIconSwords extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Swords
    name: TranslationObject = {key: 'strings:storePage.icons.swords'}
    price = 250
    image = LobbyImage.IconSwords
    activeInStore = true
}

// Player Icons with something extra

export class SIIconSombrero extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Sombrero
    name: TranslationObject = {key: 'strings:storePage.icons.sombrero'}
    price = 100
    image = LobbyImage.IconSombrero
    activeInStore = true
}

export class SIIconFarmer extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Farmer
    name: TranslationObject = {key: 'strings:storePage.icons.farmer'}
    price = 100
    image = LobbyImage.IconFarmer
    activeInStore = true
}

export class SIIconHelmet extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Helmet
    name: TranslationObject = {key: 'strings:storePage.icons.helmet'}
    price = 100
    image = LobbyImage.IconHelmet
    activeInStore = true
}

export class SIIconSnorkel extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Snorkel
    name: TranslationObject = {key: 'strings:storePage.icons.snorkel'}
    price = 100
    image = LobbyImage.IconSnorkel
    activeInStore = true
}

export class SIIconScarf extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Scarf
    name: TranslationObject = {key: 'strings:storePage.icons.scarf'}
    price = 100
    image = LobbyImage.IconScarf
    activeInStore = true
}

export class SIIconTie extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Tie
    name: TranslationObject = {key: 'strings:storePage.icons.tie'}
    price = 100
    image = LobbyImage.IconTie
    activeInStore = true
}

export class SIIconWorker extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Worker
    name: TranslationObject = {key: 'strings:storePage.icons.worker'}
    price = 100
    image = LobbyImage.IconWorker
    activeInStore = true
}

export class SIIconMummy extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Mummy
    name: TranslationObject = {key: 'strings:storePage.icons.mummy'}
    price = 400
    image = LobbyImage.IconMummy
    activeInStore = false
}

export class SIIconPlayer extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.Player
    name: TranslationObject = {key: 'strings:storePage.icons.colonist'}
    price = 0
    image = LobbyImage.User
    activeInStore = true
}

// Founder icons

export class SIIconFounderHat extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.FounderHat
    name: TranslationObject = {key: 'strings:storePage.icons.founderHat'}
    price = 100000
    image = LobbyImage.IconFounderHat
    activeInStore = false
}

export class SIIconColonistHat extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.ColonistHat
    name: TranslationObject = {key: 'strings:storePage.icons.colonisthat'}
    price = 50000
    image = LobbyImage.IconColonistHat
    activeInStore = false
}

export class SIIconSettlerHat extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.SettlerHat
    name: TranslationObject = {key: 'strings:storePage.icons.settlerHat'}
    price = 25000
    image = LobbyImage.IconSettlerHat
    activeInStore = false
}

// Medal icons

export class SIIconMedalGold extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.MedalGold
    name: TranslationObject = {key: 'strings:storePage.icons.goldMedal'}
    price = 9999999
    image = LobbyImage.IconMedalGold
    activeInStore = false
}

export class SIIconMedalSilver extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.MedalSilver
    name: TranslationObject = {key: 'strings:storePage.icons.silverMedal'}
    price = 9999999
    image = LobbyImage.IconMedalSilver
    activeInStore = false
}

export class SIIconMedalBronze extends BaseStoreItem {
    category = StoreItemCategory.Icon
    type = StoreIconType.MedalBronze
    name: TranslationObject = {key: 'strings:storePage.icons.bronzeMedal'}
    price = 9999999
    image = LobbyImage.IconMedalBronze
    activeInStore = false
}
